export default __webpack_public_path__ + "static/media/laura.bbfaaef3.png";